import { useQuery } from '@tanstack/react-query';
import { awaitJSON, MiscLambdaFetch } from '../../../utils/fetch-utils';
import { HealthCheckResult } from '../systemHealthConstants';

export const useSystemHealthData = (): ReturnType<typeof useQuery<HealthCheckResult[]>> =>
  useQuery({
    meta: { suppressGlobalError: true },
    queryKey: ['systemHealth'],
    queryFn: async (): Promise<HealthCheckResult[]> => {
      const response = await MiscLambdaFetch('/system_health', { method: 'GET' });
      return awaitJSON<HealthCheckResult[]>(response);
    }
  });
